import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import "./HrManagementHeader.scss";
import { Button } from 'react-bootstrap';
import ModalForm from '../../../../components/ModalForm/ModalForm';

export const HrManagementHeader = () => {
  const [isScrollNav, isSetScrollNav]=useState('bg-tertiary');
  const [isChangeLogo, isSetChangeLogo]=useState('qkr-biz-white');

  const [FormModal, setFormModal] = useState(false);

  const handleClose = () => {
    setFormModal(false);
  };

  const handleShow = () => {
    setFormModal(true);
  };

  useEffect(()=>{
    const handleScroll = ()=>{
      if(window.scrollY>15){
        isSetScrollNav('');
        isSetChangeLogo('qkr-biz');
      }else{
        isSetScrollNav('bg-tertiary');
        isSetChangeLogo('qkr-biz-white');
      }
    }
    window.addEventListener('scroll', handleScroll);
    return () =>{
      window.addEventListener('scroll', handleScroll);
    };
  },[])
  return (
    <>
      <Navbar expand="lg" className={`landing-header ${isScrollNav}`} variant="light" fixed="top">
        <Container>
            <Navbar.Brand as={Link} to="/hrms-software" className={isChangeLogo}>krHR</Navbar.Brand>
            <Nav className="ms-auto">
                <Nav.Link as={Link} to="tel:+917428174445">+91-7428174445</Nav.Link>
                <Nav.Link onClick={handleShow} className="freetial">Request a Demo</Nav.Link> 
            </Nav>
        </Container>
      </Navbar>
      <div className="fixed-bottom-freetial bg-white">
         {/* <div className="text-center py-1">
              <Button variant="default" onClick={handleShow} className="text-magenta fn-3 fn-m">Request a Demo</Button> 
        </div> */}
        <div className="text-center d-grid">
              <Button variant="magenta" onClick={handleShow} className="rounded-0 fn-3">Request a Demo</Button>
        </div>
      </div>

      <ModalForm show={FormModal} handleClose={handleClose} />
      
    </>
  )
}
